






import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';

import { getSettings } from '@/services/Settings';

import { captureException as sentryCaptureException } from '@sentry/browser';

export interface INotification {
	setting_key: string;
	notification_message: string;
	visible: boolean;
	public: boolean;
}

@Component
export default class Notification extends Vue {
	@State('notificationBanner', { namespace: 'Notifications' }) private notification: any;
}
